import request from "@/utils/request";

export default function agentBindBankCard(params) {
    return request({
        url: `/user/agent/agentBindBankCard`,
        method: 'post',
        params
    })
}
